import { IMAGES } from "../../presentation/assets/images/images";

export const pageProjects = [
  {
      title: "matte",
      imgSrc: IMAGES.matte,
      description: "A Matte é uma empresa dedicada ao desenvolvimento de softwares e websites para pessoas. Nossa missão é criar soluções digitais inovadoras que atendam às necessidades e superem as expectativas dos nossos clientes.",
      projectLink: "https://mattedev.com.br/",
    },
  {
      title: "pesqueiro",
      imgSrc: IMAGES.pesqueiro,
      description:
        "Destaco o site do Pesqueiro do Cirino, um projeto pra um cliente onde busquei oferecer uma experiência online envolvente para os amantes da pesca. O destaque está em um layout intuitivo, uma galeria de fotos atrativa que captura a essência do local e um design responsivo, garantindo acessibilidade em diversos dispositivos.",
      projectLink: "https://pesqueirocirino.com/",
    },
    {
      title: "bookworm",
      imgSrc: IMAGES.bookworm,
      description:
        "O projeto consiste em um e-commerce de livros, proporcionando aos usuários uma experiência amigável e intuitiva para navegar pela loja. Algumas features que valem a pena destacar: Integração da API do PayPal no processo da finalização da compra, envio de e-mail no formulário com validação, barra de pesquisa em tempo real, sistema de cadastro e carrinho de compras.",
      projectLink: "https://ecommerce-project-livid-chi.vercel.app/",
      repositoryLink: "https://github.com/devpdro/ecommerce-project",
    },
    {
      title: "auto-luxury",
      imgSrc: IMAGES.luxury, 
      description:
        "O projeto gira em torno de uma plataforma de reserva de carros de luxo, oferecendo aos usuários uma experiência simples e fácil de usar para explorar a frota com a pesquisa, selecionar os veículos desejados para reserva e finalizar suas reservas.",
      projectLink: "https://auto-luxury-project.vercel.app",
      repositoryLink: "https://github.com/devpdro/auto-luxury-project",
    },
    {
      title: "play-tv",
      imgSrc: IMAGES.tv, 
      description:
        "Este projeto proporciona aos usuários a oportunidade de mergulhar em um vasto universo de entretenimento, oferecendo acesso a uma ampla variedade de plataformas de streaming, incluindo Prime Video, Netflix, HBO e muitas outras. Aqui, os amantes de filmes e músicas podem explorar uma seleção diversificada e cativante de conteúdo.",
      projectLink: "https://play-tv-project.vercel.app/",
      repositoryLink: "https://github.com/devpdro/play-tv-project",
    },
    {
      title: "pokemundi",
      imgSrc: IMAGES.pokemundi,
      description:
        "Este projeto é uma aplicação interativa e responsiva, meticulosamente desenvolvida utilizando a poderosa estrutura Next.js. Next.js é uma estrutura de React que oferece a capacidade de criar páginas renderizadas no lado do servidor e realizar a pré-renderização, garantindo um desempenho excepcional e uma experiência de usuário excepcional.",
      projectLink: "https://pokemundi-project.vercel.app/",
      repositoryLink: "https://github.com/devpdro/pokemundi-project",
    },
    {
      title: "travel-beyond",
      imgSrc: IMAGES.travel,
      description:
        "TravelBeyond é uma plataforma excepcional que desvendará as espetaculares maravilhas da África Ocidental. Esta jornada incrível é possível graças à fusão da poderosa tecnologia React com a versatilidade do JSON, simulando uma API.",
      projectLink: "https://travel-beyond-project.vercel.app/",
      repositoryLink: "https://github.com/devpdro/travel-beyond-project",
    },
    {
      title: "foodies",
      imgSrc: IMAGES.foodies,
      description:
        "O projeto Foodies é uma expressão visual e envolvente de um restaurante que foi meticulosamente concebido com o propósito de explorar conceitos de design e proporcionar uma experiência excepcional aos usuários. Este ambiente virtual é um convite para uma jornada sensorial que combina arte, gastronomia e inovação.",
      projectLink: "https://projeto-food-two.vercel.app/",
      repositoryLink: "https://github.com/devpdro/project-foodies",
    },
    {
      title: "spotify",
      imgSrc: IMAGES.spotify,
      description:
        "Este projeto é uma reinterpretação inspirada no Spotify, transportando os usuários para um envolvente universo de música e entretenimento através de uma interface que cativa os sentidos com sua estética agradável e visualmente impactante.",
      projectLink: "https://spiffy-daffodil-c94357.netlify.app/",
      repositoryLink: "https://github.com/devpdro/project-spotify-clone",
    },
    {
      title: "finans",
      imgSrc: IMAGES.finans,
      description:
        "Este projeto, desenvolvido há algum tempo, é um testemunho do poder do design atemporal e visualmente envolvente. Apresentando um layout estático que cativa os sentidos, o projeto é uma celebração da estética harmoniosa, com gráficos e cores meticulosamente escolhidos para criar uma experiência visualmente memorável.",
      projectLink: "https://marvelous-monstera-96229f.netlify.app/",
      repositoryLink: "https://github.com/devpdro/project-finans",
      }
    ];
